export default __webpack_public_path__ + "static/media/icon_twitter.02030f74.svg";